
    var riot = require('riot')
    riot.tag2('gb-sayt-categories', '<gb-list items="{$sayt.categoryResults}"> <gb-sayt-link send="{$sayt.searchCategory}" data-value="{$item.value}" data-refinement="{$item.category}" data-field="{$sayt.categoryField}" data-norefine="{$item.noRefine}"> <yield> <gb-raw content="{$sayt.highlightCurrentQuery($item.value, \'<b>$&</b>\')}"></gb-raw> in <span class="gb-category-query">{$item.category}</span> </yield> </gb-sayt-link> </gb-list>', 'gb-sayt-categories.gb-stylish .gb-category-query,[data-is="gb-sayt-categories"].gb-stylish .gb-category-query{ font-weight: bold; color: darkorange; }', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt-categories.tag.html